export default {"src":"/_next/static/media/Ellipse 10.e5ef94d3.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};